import { InsightsSummaryDataKpi } from '../model/insights-summary-data-kpi.model';

// https://github.com/angular/angular/blob/12.1.x/packages/common/src/i18n/format_number.ts#L11
const NUMBER_FORMAT_REGEXP = /^(\d+)?\.((\d+)(-(\d+))?)?$/;

export function checkKpiFormat(kpis: InsightsSummaryDataKpi[]): void {
    try {
        kpis.forEach((e) => {
            if (!NUMBER_FORMAT_REGEXP.test(e.kpiFormat)) {
                e.kpiFormat = '1.0-0';
            }
        });
    } catch {}
}
